/* ============================================================
   Fashion City — 커스텀 상품 수량칸 초기값
   수량칸을 최소 주문 수량에서 시작하게 해 줍니다.

   ※ 예전에는 여기서 최소값 아래로 못 내려가게 '잠갔'는데, 그러면
     색을 나눠 사는 손님(검정 12 + 네이비 12)이 아예 못 담습니다.
     그래서 지금은 시작값만 잡아주고, 실제 최소 수량 확인은
     assets/fc-po-min.js 가 '주문 전체 합계' 로 처리합니다.

   ★ 최소 수량 숫자는 assets/fc-po-min.js 의 MIN_BY_HANDLE 한 곳에만 있습니다.
     이 파일은 그 표를 가져다 쓸 뿐이니 여기 숫자를 적지 마세요.
   ============================================================ */
(function () {
  var TABLE = window.FC_MIN_BY_HANDLE || {};

  var path = String(window.location.pathname);
  var at = path.indexOf('/products/');
  if (at < 0) return;
  var handle = path.slice(at + 10).split('?')[0].split('#')[0].split('/')[0];

  var min = TABLE[handle];
  if (!min) return;

  var SELECTOR = [
    'input[name="quantity"]',
    'input[data-quantity-input]',
    'quantity-input input[type="number"]',
    '.quantity-input input',
    '.quantity-selector input',
    'input.js-qty__num'
  ].join(',');

  function apply() {
    var inputs = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.dataset.fcQtyInit) continue;
      input.dataset.fcQtyInit = '1';
      input.setAttribute('step', '1');
      input.setAttribute('min', '1');
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v <= 1) {
        input.value = min;
        try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }
    }
  }

  function boot() {
    apply();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; apply(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();